import { useMutation, useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from 'constants/endpoints';
import { get, handleError, handleResponse, post, del } from './base.service';

export const useAddAStoryMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.STORY, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useStaticAddStoryMutation = () =>
	useMutation({
		mutationFn: (payload: any) => {
			return post(API_ENDPOINTS.STATIC_CREATE_STORY, payload);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useGetStoriesQuery = () =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.STORY_LIST}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-stories'],
		refetchOnWindowFocus: false,
	});

export const useGetStaticStoriesQuery = () =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.STATIC_STORY_LIST}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-static-stories'],
		refetchOnWindowFocus: false,
	});

export const useStoryViewersQuery = ({ id, searchString }: any) =>
	useQuery({
		queryFn: async () => {
			try {
				const response = await get(`${API_ENDPOINTS.STORY_VIEWERS}/${id}?${searchString}`);
				return handleResponse(response);
			} catch (err) {
				handleError(err);
			}
		},
		queryKey: ['get-story-viewers', id, searchString],
		refetchOnWindowFocus: false,
		enabled: !!id,
	});

export const useStoryViewersMutation = () =>
	useMutation({
		mutationFn: (id: number) => {
			return get(`${API_ENDPOINTS.STORY_VIEWERS}/${id}`);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useStoryViewedMutation = () =>
	useMutation({
		mutationFn: (storyId: any) => {
			return post(API_ENDPOINTS.STORY_VIEW, storyId);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});

export const useDeleteStoryMutation = () =>
	useMutation({
		mutationFn: (id: number | null = null) => {
			return del(`${API_ENDPOINTS.STORY}/${id}`);
		},
		onSuccess: handleResponse,
		onError: handleError,
	});
